import type { AppDispatch, RootState } from '../store';
import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
